var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-input',_vm._g(_vm._b({model:{value:(_vm.emailAddress),callback:function ($$v) {_vm.emailAddress=$$v},expression:"emailAddress"}},'vx-input',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }